import { render, staticRenderFns } from "./ledgerRole.vue?vue&type=template&id=a267b79a&scoped=true&"
import script from "./ledgerRole.vue?vue&type=script&lang=js&"
export * from "./ledgerRole.vue?vue&type=script&lang=js&"
import style0 from "./ledgerRole.vue?vue&type=style&index=0&id=a267b79a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267b79a",
  null
  
)

export default component.exports